import script from "./ProjectsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsBlock.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsBlock.vue?vue&type=style&index=0&id=07c1af0c&lang=scss"

const __exports__ = script;

export default __exports__